module.exports = __webpack_public_path__ + "static/media/contact-img.a8822e20.svg";